import { get, post, patch, put, httpDelete } from '../../utils/http';

export const getBillingGroups = () => get(`/invoicing/groups`);

export const getInvoicingAccountBranches = ({ accountId }) => get(`/invoicing/accounts/${accountId}/branches`);

export const createBillingGroup = ({ body }) => post(`/invoicing/groups`, body);

export const updateBillingGroup = ({ groupId, ...payload }) => patch(`/invoicing/groups/${groupId}`, { ...payload });

export const deleteBillingGroup = ({ groupId }) => httpDelete(`/invoicing/groups/${groupId}`);

export const getInvoicingPreview = ({ period, groupId }) => post(`/invoicing/preview`, { period, groupId });

export const createInvoicingDrafts = ({ period, groupIds, invoiceOverrides }) =>
  post(`/invoicing/drafts`, { period, groupIds, invoiceOverrides });

export const getInvoicingFxRates = () => get(`/invoicing/fx-rates`);

export const updateInvoicingFxRates = ({ baseCurrency, rates }) => put(`/invoicing/fx-rates`, { baseCurrency, rates });

export const getInvoicingInvoices = ({ groupId, period } = {}) =>
  get(`/invoicing/invoices`, { ...(groupId ? { groupId } : {}), ...(period ? { period } : {}) });
